module.exports = __webpack_public_path__ + "img/alert-circle.b00f2c82.svg";